import React from "react";
import { ArrowRight, CreditCard, Plane, Gift } from "lucide-react";
import { setUserClickData } from "../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import callApi from "../../utility/apiCaller";

function BPCreditCard({ Lead_id, name, contact_phone }) {
  const [params] = useSearchParams();
  const affId = params.get("aff_id") || "";
  const utmSource = params.get("utm_source") || "";
  const leadId = params.get("lid") || "";

  const handleClick = async () => {
    try {
      // Set user click data
      setUserClickData({
        event_name: "click-bharatpe-creditcard-ad",
        utm_source: utmSource,
        user_id: Lead_id || "No User ID found here",
        affiliate_id: affId || "No Aff_id found",
      });

      // Send SMS via API
      // const smsResponse = await callApi(
      //   `v1/sms/send-sms-bharatpe-creditcard`,
      //   "post",
      //   {
      //     data: {
      //       lead: {
      //         id: Lead_id,
      //         contact_phone: contact_phone,
      //         contact_name: name,
      //       },
      //     },
      //   },
      //   "messaging"
      // );

      // console.log("SMS sent successfully:", smsResponse);

      // Redirect only if SMS is successful
      window.location.assign("https://link.postpe.app/CHvc/bpdigimny");
    } catch (error) {
      console.error("Error sending SMS or handling click:", error);

      // Optionally, show an error message to the user
      alert(
        "Something went wrong while sending the SMS. Please try again later."
      );
    }
  };

  return (
    <div className="w-full max-w-[360px] h-auto relative bg-purple-950  overflow-hidden  mx-auto py-10 px-4 mt-2 rounded-[20px]  flex flex-col items-center transition z-0">
      {/* Header Text */}

      <img
        src="assets/img/47784809f6d8b567618c5eaee37dd1f17f1bc8ef.webp"
        className="absolute inset-0 -z-0 w-full h-full object-cover scale-[1.5]  bg-blend-normal object-left-top rounded-[20px] rotate-180"
      />
      <h2 className="text-[24px] font-polysans font-semibold text-[#FFFFFF] text-center mb-1 z-10">
        Get More with DigitMoney
      </h2>
      <p className="text-[#A77EEE] text-center font-polysans text-[15px] mb-3 leading-tight z-10 px-4 py-2">
        Apply for your{" "}
        <span className=" text-[#FFF200] font-semibold ">
          BharatPe Credit Card
        </span>{" "}
        Today and unlock rewards.
      </p>

      {/* Card Image */}
      <img
        src="/assets/img/b46abdbf4d3d477425122256e02e34e3262bcf8f.png"
        className="h-auto w-[300px] rounded-lg shadow-sm mb-2 z-10"
        alt="Unity Bank BharatPe Credit Card"
      />

      {/* Card Title */}
      <h3 className=" py-3 text-[#FFFFFF] font-polysans text-[22px] mb-2 z-10">
        BharatPe Credit Card
      </h3>

      {/* Benefits */}
      <ul className="space-y-2 mx-auto font-polysans  items-center max-w-[85%] text-[14px] text-[#BB94FF] w-full  z-10">
        <li className="flex gap-2 items-center">
          <CreditCard size={18} className="text-[#FFF200]" />
          Free Credit Card with no joining fees
        </li>

        <li className="flex gap-2 items-center">
          <Gift size={18} className="text-[#FFF200]" />
          Cashback & reward points
        </li>
        <li className="flex gap-2 items-center">
          <Plane size={18} className="text-[#FFF200]" />8 Complimentary
          Lounge access{" "}
        </li>
      </ul>

      {/* CTA */}
      <button
        onClick={handleClick}
        className="flex gap-2  font-polysans text-[16px] justify-center  mt-4 bg-[#FFF200] hover:bg-yellow-600 transition-colors text-black  px-5 py-3 rounded-full shadow-md z-10 items-center"
      >
        Apply Now
        <img src="/assets/img/Layer_1 (10).png" className="w-[21px] h-[16px]" />
      </button>
    </div>
  );
}

export default BPCreditCard;
